<template>
  <v-container
    id="detalhe-valor-a-vencer"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :url="link"
        />
        <v-divider class="mb-5" />
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <h3 class="text-center">
                        Contas a pagar por fornecedor em aberto
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        id="idTable"
                        style="overflow-x: auto;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 40%;"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 15%;"
                              >
                                Código lançamento
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 15%;"
                              >
                                Dias vencido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 15%;"
                              >
                                Aberto
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 15%;"
                              >
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="(item, index) in dadosDetalhamento"
                            :key="item.id"
                          >
                            <!-- Linha principal -->
                            <tr>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 40%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left; width: 15%;"
                              >
                                <button
                                  @click="toggleExpand(index)"
                                >
                                  {{ expanded.includes(index) ? '▲' : '▼' }}
                                </button>
                                {{ item.cod_lancamento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                                :style="getColorAberto(item.aberto)"
                              >
                                {{ item.aberto }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 15%;"
                              >
                                {{ item.total }}
                              </td>
                            </tr>
                            <!-- Linha expandida -->
                            <tr
                              v-if="expanded.includes(index)"
                              :key="'expanded-' + item.id"
                            >
                              <td colspan="10">
                                <table
                                  id="tableExpandida"
                                  style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                                >
                                  <tbody>
                                    <tr
                                      v-for="(sub, idx) in item.dadosCodLancamento"
                                      :key="idx"
                                    >
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left; width: 40%;"
                                        :style="getNomeReduzido(sub.nome_reduzido)"
                                      >
                                        {{ sub.nome_reduzido }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: left; width: 15%;"
                                      >
                                        {{ sub.cod_lancamento }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 15%;"
                                      >
                                        {{ sub.dias_vencido }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 15%;"
                                        :style="getColorAberto(sub.aberto)"
                                      >
                                        R$ {{ sub.aberto }}
                                      </td>
                                      <td
                                        id="dadoMovimentacao"
                                        style="text-align: right; width: 15%;"
                                      >
                                        R$ {{ sub.total }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasPagar from '../../../../../services/contaspagar'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasAVencerDetalhamento',
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectValorPago: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObjectValorAberto: {
        color: '#f27686',
      },
      styleObjectIcon: {
        color: '#4780b8',
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      link: localStorage.linkContasPagar,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersDetalhamento: [
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '350px', class: 'black--text title' },
        { text: 'Código lançamento', value: 'cod_lancamento', width: '250px', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Aberto', value: 'aberto', width: '150px', align: 'right', class: 'black--text title' },
        { text: 'Total', value: 'total', width: '150px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoCategoria: [],
      expandDetalhamento: false,
      iconeSubcategoria: 'mdi-plus',
      expandSubcategoria: false,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      expanded: [],
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showContasAVencerDadosDelhamento()
      },

      async showContasAVencerDadosDelhamento () {
        this.loading = true

        await ContasPagar.showDadosDelhamentoAVencer(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                nome_reduzido: item.nome_reduzido,
                cod_lancamento: item.cod_lancamento,
                dias_vencido: item.dias_vencido,
                total: parseFloat(item.total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                aberto: parseFloat(item.aberto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                dadosCodLancamento: item.dadosCodLancamento,
                icone: item.icone,
                expandir: item.expandir,
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para detalhamento no período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      expandedCodLancamento (value) {
        if (value.icone === 'mdi-plus') {
          this.expandDetalhamento = true
          value.expandir = true
          value.icone = 'mdi-minus'
        } else {
          this.expandDetalhamento = false
          value.icone = 'mdi-plus'
          value.expandir = false
        }
      },

      getColorAberto (value) {
        return 'color: #f27686'
      },

      getNomeReduzido (value) {
        return 'color: transparent'
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      /* max-height: 500px; */
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    /* max-height: 500px; */
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #ul_product
    list-style-type: none

  #headerTablePrincipal
    margin: -2rem 0 0 0

  #dadosId
    margin: -3rem 0 0 -1rem

  #idDadosNomeReduzidoVencer
    margin: -1rem 0 0 0

  #idDadosCodLancamentoVencer
    margin: -1rem 0 0 0

  #idDadosDiasVencidoVencer
    margin: -1rem 0 0 0

  #idDadosTotalVencer
    margin: -1rem 0 0 0

  #idDadosAbertoVencer
    margin: -1rem 0 0 0

  #dividerTr
    margin: -1rem 0 0 0

  #headers
    margin: -1.5rem 0 1rem 0

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
</style>
